var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BModal",
    {
      staticClass: "new-customer",
      attrs: { active: "" },
      on: { close: _vm.cancelModal }
    },
    [
      _c("header", { staticClass: "modal-card-head" }, [
        _c("p", { staticClass: "modal-card-title has-text-primary" }, [
          _vm._v("\n      " + _vm._s(_vm.clientName) + "\n    ")
        ])
      ]),
      _c("div", { staticClass: "modal-card-body" }, [
        _c(
          "div",
          { staticClass: "column is-12" },
          [
            _c(
              "BField",
              {
                attrs: {
                  label: "Límite de crédito necesario",
                  "label-for": "customerDebtLimit"
                }
              },
              [_vm._v("\n        " + _vm._s(_vm.limit || 0) + "\n      ")]
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "column is-12" },
          [
            _c(
              "BField",
              { attrs: { label: "Deuda Actual", "label-for": "customerDebt" } },
              [_vm._v("\n        " + _vm._s(_vm.debt || 0) + "\n      ")]
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "column is-12" },
          [
            _c(
              "BField",
              {
                attrs: {
                  label: "Limite de crédito",
                  "label-for": "privateCreditLimit"
                }
              },
              [
                _c("BInput", {
                  attrs: {
                    id: "privateCreditLimit",
                    placeholder: "30",
                    icon: "bank",
                    required: ""
                  },
                  on: {
                    input: function($event) {
                      return _vm.onInput("creditLimit", $event)
                    }
                  },
                  model: {
                    value: _vm.privateCreditLimit,
                    callback: function($$v) {
                      _vm.privateCreditLimit = $$v
                    },
                    expression: "privateCreditLimit"
                  }
                })
              ],
              1
            ),
            _c("p", { staticClass: "help" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm._f("toCurrency")(_vm.privateCreditLimit, "MXN")) +
                  "\n      "
              )
            ])
          ],
          1
        )
      ]),
      _c("footer", { staticClass: "modal-card-foot" }, [
        _c("p", { staticClass: "control" }, [
          _c(
            "button",
            {
              staticClass: "button is-success",
              on: {
                click: function($event) {
                  return _vm.closeModal(true)
                }
              }
            },
            [_vm._v("\n        Guardar\n      ")]
          ),
          _c(
            "button",
            {
              staticClass: "button",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.closeModal(false)
                }
              }
            },
            [_vm._v("\n        Cerrar\n      ")]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }